<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_316_3261)">
      <mask
        id="mask0_316_3261"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <path d="M0 -7.62939e-06H36V36H0V-7.62939e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_316_3261)">
        <path
          d="M17.2098 19.1107L11.6319 24.6886C11.5658 24.7548 11.6127 24.8681 11.7063 24.8681H15.3306C15.4243 24.8681 15.4712 24.9813 15.4049 25.0475L9.03088 31.4216C8.9439 31.5085 9.05134 31.6484 9.15772 31.5869L22.047 24.1453C22.1281 24.0985 22.1122 23.977 22.0217 23.9527L19.3102 23.2262C19.2321 23.2052 19.2059 23.1076 19.2818 23.0687L23 18.9998"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M28.0458 20.9996L27 22.0454"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.04583 20.9997L8 22.0454"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.08769 28.6793L2.17969 30.5874"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.759 24.9998L25 26.7588"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.84981 31.0677L3.95898 33.9585"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.7906 31.1561L12.2227 33.7241"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.72394 25.9998L8 26.7236"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.3724 28.3122L17.8672 31.8174"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.7841 27.6534L28.373 30.0645"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path
        d="M27.5003 9.15966C25.9641 5.70332 22.4756 2.99974 18.5 2.99974C14.5167 2.99974 11.0323 5.71139 9.4997 9.15966C7.03452 9.22554 5 11.2431 5 13.7242C5 16.2469 7.10107 18.292 9.62378 18.292H27.3762C29.8989 18.292 32 16.2469 32 13.7242C32 11.2431 29.9655 9.22554 27.5003 9.15966Z"
        class="stroke-current"
        stroke-width="2.39004"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 24C6.5 24.8284 5.82841 25.5 5 25.5C4.17159 25.5 3.5 24.8284 3.5 24C3.5 23.1716 4.17159 22.5 5 22.5C5.82841 22.5 6.5 23.1716 6.5 24Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.25 31.25C25.25 32.0784 24.5784 32.75 23.75 32.75C22.9216 32.75 22.25 32.0784 22.25 31.25C22.25 30.4216 22.9216 29.75 23.75 29.75C24.5784 29.75 25.25 30.4216 25.25 31.25Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.25 23.25C33.25 24.0784 32.5784 24.75 31.75 24.75C30.9216 24.75 30.25 24.0784 30.25 23.25C30.25 22.4216 30.9216 21.75 31.75 21.75C32.5784 21.75 33.25 22.4216 33.25 23.25Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_316_3261">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
